import StyledButton from '../../components/Button/Button';
import { buttonVariant } from '../../types/buttonTypes';

import { Grid, GridItem, BoxProps } from '@chakra-ui/react';
import { Box, Text, Image } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';

export interface ContentImageProps extends BoxProps {
    image: {
        url: string;
        alt: string;
    };
    title: string;
    layout_order: 'image_left' | 'image_right' | 'image_bottom';
    subtitle?: string;
    children: string | JSX.Element | JSX.Element;
    padding: string;
    ctaButton?: {
        title: string;
        href: string;
        variant: buttonVariant;
    };
    bgColor: string;
    titleColor?: string;
}

const ContentImage: React.FC<ContentImageProps> = ({
    image,
    title,
    layout_order,
    subtitle,
    children,
    ctaButton,
    padding,
    bgColor,
    titleColor,
    ...rest
}) => {
    return (
        <Grid
            _before={{
                content: '""',
                position: 'absolute',
                height: '100%',
                top: 0,
                width: '100vw',
                marginLeft: '50%',
                left: '-50vw',
                zIndex: -2,
                backgroundColor: bgColor == 'gray' ? 'rgba(238, 238, 238, 1)' : '',
            }}
            padding={padding ? { base: '0', md: padding } : { base: '0', md: '5rem 0' }}
            position={'relative'}
            {...rest}
        >
            <Grid
                templateColumns="repeat(, 1fr)"
                gap="30px"
                gridTemplateColumns={{
                    sm: 'templateColumns="1fr"',
                    lg: 'repeat(2, 1fr)',
                }}
            >
                <Flex
                    justifyContent={{
                        base: 'center',
                        lg: 'left',
                    }}
                >
                    <Image
                        mx={{
                            sm: 'left',
                            lg: 'initial',
                        }}
                        src={image.url}
                        alt={image.alt}
                    />
                </Flex>
                <Flex
                    flexDirection="column"
                    alignItems="flex-start"
                    justifyContent="center"
                    order={layout_order === 'image_left' ? '' : '-1'}
                >
                    <>
                        <Text
                            fontSize="30px"
                            fontWeight={'600'}
                            color={titleColor ? titleColor : 'black'}
                            mb="30px"
                            as="b"
                            textAlign="left"
                        >
                            {title}
                        </Text>
                        {subtitle && (
                            <Text
                                fontSize="21px"
                                color={'#171717'}
                                fontWeight={'600'}
                                mb="5px"
                                as="b"
                                textAlign="left"
                            >
                                {subtitle}
                            </Text>
                        )}
                        <Flex
                            gap={'15px'}
                            flexDirection={'column'}
                            fontSize={'16px'}
                            color={'#171717'}
                            marginBottom={'30px'}
                        >
                            {children}
                        </Flex>
                        {ctaButton && (
                            <StyledButton
                                href={ctaButton.href}
                                style={ctaButton.variant}
                                target="_blank"
                            >
                                {ctaButton.title}
                            </StyledButton>
                        )}
                    </>
                </Flex>
            </Grid>
        </Grid>
    );
};

export default ContentImage;
